import React from 'react';

interface ProgressStepProps {
  label: string;
  isCompleted: boolean;
  isActive: boolean;
  number: number;
}

const ProgressStep: React.FC<ProgressStepProps> = ({ label, isCompleted, isActive, number }) => {
  return (
    <div className="flex items-center gap-1">
      <div className={`flex items-center justify-center text-[14px] font-medium
        ${isCompleted ? 'text-[#222222]' : 'text-[#75757599]'}`}
      >
        {number}.
      </div>
      <span className={`text-[14px] font-medium
        ${isCompleted ? 'text-[#222222]' : 'text-[#75757599]'}`}
      >
        {label}
      </span>
    </div>
  );
};

export default ProgressStep; 